<template>
  <VModal ref="modal" disable-backdrop-click @close="$emit('close')">
    <div class="mx-auto bg-white rounded-lg text-left shadow-xl lg:max-w-lg sm:w-full">
      <BaseCard>
        <BaseCardHeader>
          <div class="flex justify-between items-center">
            <div class="flex-1">{{ $t('selectSavedQueryModal.title') }}</div>
            <div class="flex-none">
              <button
                type="button"
                class="rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                @click="closeModal"
              >
                <span class="sr-only">{{ $t('global.closeDialog') }}</span>
                <svg
                  class="inline-flex h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </BaseCardHeader>
        <BaseCardBody clear-padding>
          <BaseDataIterator :service="fetchSavedQueries" nested disable-header>
            <template #default="{ data }">
              <BaseStackedList :data="data">
                <template #default="{ item }">
                  <div class="px-4 py-3 sm:px-6">
                    <div class="flex items-center space-x-4">
                      <div class="flex-1 min-w-0">
                        <h3 class="text-sm font-semibold text-gray-800">
                          {{ item.name }}
                        </h3>
                        <p class="mt-1 text-sm text-gray-600 line-clamp-2">
                          {{ item.description || 'No description available' }}
                        </p>
                      </div>
                      <div>
                        <BaseButton type="button" primary outline small @click="handleSelect(item)">
                          {{ $t('global.select') }}
                        </BaseButton>
                      </div>
                    </div>
                  </div>
                </template>
              </BaseStackedList>
            </template>
          </BaseDataIterator>
        </BaseCardBody>
      </BaseCard>
    </div>
  </VModal>
</template>

<script>
export default {
  name: 'SelectSavedQueryModal',
  props: {
    action: {
      type: Function,
      default: () => Promise.resolve(),
    },
  },
  methods: {
    async fetchSavedQueries() {
      try {
        const response = await this.action();

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    closeModal() {
      this.$refs.modal.close();
    },
    handleSelect(savedQuery) {
      this.$emit('input', savedQuery);
      this.closeModal();
    },
  },
};
</script>
